import { numToDecimals } from '@teinor/erp/prices'
import { useCallback } from 'react'
import { ITHookFunctionTy, ITLayoutTableOnChangeInputs } from '../../../baseComponents/TwinTable/InputTableLayout/InputTable/types'
import { useOrderLayoutTableLogic } from '../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderTable/useOrderLayoutTableLogic'
import useInputTableFilterFnc from '../orders/useInputTableFilterFnc'

const useSelectRemittanceHook: ITHookFunctionTy = (props) => {
    const myOnChange: ITLayoutTableOnChangeInputs = useCallback((rowIndex, keyValue, value) => {
        props.setCompleteData((old) => {
            if (!old) {
                return null
            }
            const copyOld = JSON.parse(JSON.stringify(old))
            if (copyOld.tableData[rowIndex]?.[keyValue]) {
                const product = copyOld.tableData[rowIndex]
                copyOld.tableData[rowIndex][keyValue] = value
                copyOld.tableData[rowIndex].quantity2 = numToDecimals(parseFloat(String(value)) * parseFloat(String(copyOld.tableData[rowIndex].quantity2base)), 8)
                copyOld.selectedProducts[product.id][keyValue] = value
            }
            return copyOld
        })
    }, [props])

    const { ...rest } = useOrderLayoutTableLogic({
        ...props, customFunctions: {
            onChange: myOnChange,
            onChangeAdd: myOnChange as any,
            onChangeFetch: myOnChange,
            onChangeTotals: myOnChange,
            onChangeTotalsFetch: myOnChange
    }})

    const { onChangeSearchBar, changeSingleField } = useInputTableFilterFnc({ setCompleteData: props.setCompleteData as any })


    return { ...rest, onChangeSearchBar, changeSingleField }
}

export default useSelectRemittanceHook